import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=66360fb3&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=ts&"
export * from "./Module.vue?vue&type=script&lang=ts&"
import style0 from "./Module.vue?vue&type=style&index=0&id=66360fb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66360fb3",
  null
  
)

export default component.exports